export const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1300 },
        items: 6,
        slidesToSlide: 2,
    },
    desktop: {
        breakpoint: { max: 1300, min: 1024 },
        items: 4,
        slidesToSlide: 2,
    },
    tablet: {
        breakpoint: { max: 1024, min: 655 },
        items: 3,
        slidesToSlide: 2,
    },
    mobile: {
        breakpoint: { max: 655, min: 0 },
        items: 2,
        slidesToSlide: 2,
    },
};

export const responsive2 = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 1300 },
        items: 1,
        slidesToSlide: 1,
    },
    desktop: {
        breakpoint: { max: 1300, min: 1024 },
        items: 1,
        slidesToSlide: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 655 },
        items: 1,
        slidesToSlide: 1,
    },
    mobile: {
        breakpoint: { max: 655, min: 0 },
        items: 1,
        slidesToSlide: 1,
    },
};
